import request from "@ky/sdk/dist/request";

export const login = async () => {
  const res = await request.get(
    "/rest/n/kmovie/app/activity/kling/checkLogin",
    {
      params: {
        __redirectURL: window.location.href,
      },
    },
  );
  return res as Promise<{
    result: 1 | 154_004 | 154_002 | 154_037;
    data?: { ksUid: number; kyUid: number };
    errorMsg?: string;
  }>;
};
